<template>
    <div id="new-wine">
        <div class="new-wine-wrap">
            <div class="new-wine-pad">
                <div class="new-wine-col-25">
                    <div id="new-wine-image-preview"></div>
                    <input type="file" id="fileElem" accept="image/*" style="display:none" @change="previewImage()">
                    <div v-on:click="handleImageClick()" class="new-blog-post-image-button add-paragraph-button">
                        Velja mynd
                    </div>
                    <div class="new-wine-agerating-wrap">
                        <div class="new-wine-agerating-title">Árgangar</div>
                        <div v-for="(rating, index) in currentWine.ageRating" :key="rating.year" class="new-wine-agerating">
                            <div class="new-wine-agerating-col">
                                <div class="new-wine-agerating-year">Ár</div>
                                <input type="text" v-model="rating.year">
                            </div>
                            <div class="new-wine-agerating-col">
                                <div class="new-wine-agerating-rating">Einkunn</div>
                                <input type="text" v-model="rating.rating">
                            </div>
                            <div class="new-wine-agerating-col">
                                <div v-on:click="deleteAgeRating(index)" class="new-wine-agerating-delete">Eyða</div>
                            </div>
                        </div>
                        <div v-on:click="addAgeRating()" class="new-wine-agerating-add">Bæta við</div>
                    </div>
                        
                </div>
                <div class="new-wine-col-45">
                    <div class="new-wine-input wine-input-long"><div class="new-wine-input-text">Nafn</div><input type="text" v-model="currentWine.name"></div>
                    <div class="new-wine-input wine-input-long"><div class="new-wine-input-text">Lýsing</div><textarea rows="4" type="text" v-model="currentWine.description"/></div>
                    <div class="new-wine-input wine-input-long"><div class="new-wine-input-text">Einkunn</div><input type="text" v-model="currentWine.rating"></div>
                    <div class="new-wine-sliders-wrap">
                        <div class="new-wine-sliders-title">Einkenni</div>
                        <div class="new-wine-slider">
                            <p>Létt</p>
                            <input id="rangeslider1" class="rangeslider" v-model="currentWine.characteristics1" type="range" min="0" max="100" step="10" value="50">
                            <p>Fylling</p>
                        </div>
                        <div class="new-wine-slider">
                            <p>Mjúkt</p>
                            <input id="rangeslider2" class="rangeslider" v-model="currentWine.characteristics2" type="range" min="0" max="100" step="10" value="50">
                            <p>Tannískt</p>
                        </div>
                        <div class="new-wine-slider">
                            <p>Þurrt</p>
                            <input id="rangeslider3" class="rangeslider" v-model="currentWine.characteristics3" type="range" min="0" max="100" step="10" value="50">
                            <p>Sætt</p>
                        </div>
                        <div class="new-wine-slider">
                            <p>Engin sýra</p>
                            <input id="rangeslider4" class="rangeslider" v-model="currentWine.characteristics4" type="range" min="0" max="100" step="10" value="50">
                            <p>Mikil sýra</p>
                        </div>
                    </div>
                    <div class="edit-wine-relation-title">Vín sem við mælum með</div>
                    <div class="edit-wine-relation-wrap">
                        <div class="edit-wine-relation">
                            <select class="new-wine-select" v-model="currentWine.relationWine1">
                                <option value="">---</option>
                                <option v-for="wine in sortAlphabetically(wines)" :key="wine.id" :value="wine.id">{{ wine.name }}</option>
                            </select>
                        </div>
                        <div class="edit-wine-relation">
                            <select class="new-wine-select" v-model="currentWine.relationWine2">
                                <option value="">---</option>
                                <option v-for="wine in sortAlphabetically(wines)" :key="wine.id" :value="wine.id">{{ wine.name }}</option>
                            </select>
                        </div>
                        <div class="edit-wine-relation">
                            <select class="new-wine-select" v-model="currentWine.relationWine3">
                                <option value="">---</option>
                                <option v-for="wine in sortAlphabetically(wines)" :key="wine.id" :value="wine.id">{{ wine.name }}</option>
                            </select>
                        </div>
                        <div class="edit-wine-relation">
                            <select class="new-wine-select" v-model="currentWine.relationWine4">
                                <option value="">---</option>
                                <option v-for="wine in sortAlphabetically(wines)" :key="wine.id" :value="wine.id">{{ wine.name }}</option>
                            </select>
                        </div>
                    </div>
                </div>
                <div class="new-wine-col-30">
                    <div class="new-wine-input wine-input-short"><div class="new-wine-input-text">Tegund</div>
                        <select class="new-wine-select" v-model="currentWine.type">
                            <option value="red">Rauðvín</option>
                            <option value="white">Hvítvín</option>
                            <option value="boxwine">Kassavín</option>
                            <option value="sparkling">Freyðivín</option>
                            <option value="rose">Rósavín</option>
                            <option value="portwine">Púrtvín</option>
                            <option value="other">Annað</option>
                        </select>
                    </div>
                    <div class="new-wine-input wine-input-short">
                        <div class="new-wine-input-text">Land</div>
                        <select class="new-wine-select" v-model="currentWine.country">
                            <option v-for="country in countries" :key="country.id" :value="country.name">{{country.name}}</option>
                        </select>
                    </div>
                    <div class="new-wine-input wine-input-short"><div class="new-wine-input-text">Svæði</div><input type="text" v-model="currentWine.area"></div>
                    <div class="new-wine-input wine-input-short"><div class="new-wine-input-text">Verð í vínbúð</div><input type="text" v-model="currentWine.price1"></div>
                    <div class="new-wine-input wine-input-short"><div class="new-wine-input-text">Linkur á vínbúð</div><input type="text" v-model="currentWine.storelink1"></div>
                    <div class="new-wine-input wine-input-short"><div class="new-wine-input-text">Verð í fríhöfn</div><input type="text" v-model="currentWine.price2"></div>
                    <div class="new-wine-input wine-input-short"><div class="new-wine-input-text">Linkur á fríhöfn</div><input type="text" v-model="currentWine.storelink2"></div>
                    <div class="new-wine-input wine-input-short"><div class="new-wine-input-text">Framleiðandi</div><input type="text" v-model="currentWine.producer"></div>
                    <div class="new-wine-input wine-input-short"><div class="new-wine-input-text">Þrúgur</div><input type="text" v-model="currentWine.grapes"></div>
                    <div class="new-wine-input wine-input-short"><div class="new-wine-input-text">Áfengisprósenta</div><input type="text" v-model="currentWine.percentage"></div>
                </div>
                <div class="new-wine-categories-title">Flokkar</div>
                <div class="new-wine-categories-wrap">
                    <div v-for="category in categories" :id="category.id" :key="category.id" v-on:click="addCategory(category)" class="new-wine-category">{{ category.name }}</div>
                </div>
                <div class="new-wine-buttons">
                    <div v-on:click="finalizeWine(); $emit('finish')" class="add-paragraph-button">Vista</div>
                    <div v-on:click="showDeletePostModal()" class="add-paragraph-button red-button">Eyða</div>
                    <div class="new-wine-published">
                        Sýnilegt
                        <input type="checkbox" id="checkbox" v-model="currentWine.visibility">
                    </div>
                </div>
            </div>
        </div>
        
    </div>
</template>

<script>
const fb = require('../firebaseConfig.js')
import $ from 'jquery'
import { mapState } from 'vuex'

export default {
    data() {
        return {
            currentWine: {
                name: "",
                description: "",
                type: "",
                rating: "",
                country: "",
                price1: "",
                price2: "",
                storelink1: "",
                storelink2: "",
                producer: "",
                area: "",
                grapes: "",
                percentage: "",
                image: "",
                characteristics1: 50,
                characteristics2: 50,
                characteristics3: 50,
                characteristics4: 50,
                relationWine1: "",
                relationWine2: "",
                relationWine3: "",
                relationWine4: "",
                visibility: true,
                categories: [],
                ageRating: [],
                dateCreated: new Date().toISOString()
            },
        }
    },
    methods: {
        handleImageClick: function() {
            document.getElementById("fileElem").click()
        },
        previewImage: function() {
            var file = document.getElementById("fileElem").files[0]
            var reader = new FileReader()
            reader.onload = function (e) {
                var img = new Image();
                img.src = e.target.result
                document.getElementById('new-wine-image-preview').innerHTML = ''
                document.getElementById('new-wine-image-preview').appendChild(img)
            }
            reader.readAsDataURL(file)            
        },
        uploadImage: function() {
            const cloudName = 'dkq6zer55';
            const unsignedUploadPreset = 'yrdba4rz';
            
            var myData = this
            var file = document.getElementById("fileElem").files[0]
            var url = `https://api.cloudinary.com/v1_1/${cloudName}/upload`
            var xhr = new XMLHttpRequest()
            var fd = new FormData()
            xhr.open('POST', url, false)
            xhr.setRequestHeader('X-Requested-With', "XMLHttpRequest")

            xhr.onreadystatechange = function() {
                if (xhr.readyState == 4 && xhr.status == 200) {
                    var response = JSON.parse(xhr.responseText)
                    var url = response.secure_url

                    myData.currentWine.image = url
                }
            }

            fd.append('upload_preset', unsignedUploadPreset)
            fd.append('tags', 'blog_image_upload')
            fd.append('file', file)
            xhr.send(fd)
        },
        finalizeWine: function() {
            this.uploadImage()
            this.newWine()
        },
        newWine: function() {
            fb.winesCollection.add({
                name: this.currentWine.name,
                description: this.currentWine.description,
                rating: this.currentWine.rating,
                type: this.currentWine.type,
                country: this.currentWine.country,
                price1: this.currentWine.price1,
                price2: this.currentWine.price2,
                storelink1: this.currentWine.storelink1,
                storelink2: this.currentWine.storelink2,
                producer: this.currentWine.producer,
                area: this.currentWine.area,
                grapes: this.currentWine.grapes,
                percentage: this.currentWine.percentage,
                image: this.currentWine.image,
                characteristics1: this.currentWine.characteristics1,
                characteristics2: this.currentWine.characteristics2,
                characteristics3: this.currentWine.characteristics3,
                characteristics4: this.currentWine.characteristics4,
                relationWine1: this.currentWine.relationWine1,
                relationWine2: this.currentWine.relationWine2,
                relationWine3: this.currentWine.relationWine3,
                relationWine4: this.currentWine.relationWine4,
                visibility: this.currentWine.visibility,
                categories: this.currentWine.categories,
                ageRating: this.currentWine.ageRating,
                dateCreated: this.currentWine.dateCreated
            })
        },
        addCategory: function(category) {
            if (this.currentWine.categories.includes(category.id)) {
                var index = this.currentWine.categories.indexOf(category.id)
                if (index !== -1) {
                    this.currentWine.categories.splice(index, 1)
                }
            } else {
                this.currentWine.categories.push(category.id)
            }
        },
        addAgeRating: function() {
            this.currentWine.ageRating.push({rating:'', year:''})
        },
        deleteAgeRating: function(index) {
            this.currentWine.ageRating.splice(index, 1)
        },
        sortAlphabetically(list) {
            var listCopy = list.slice()
            listCopy.sort(function(a, b) {
                var item1 = a.name
                var item2 = b.name
                return (item1 < item2) ? -1: (item1 > item2) ? 1 : 0
            })
            return listCopy
        },
    },
    mounted: function() {
        $(".new-wine-category").click(function() {
            $(this).toggleClass("active-category")
        })

        //
        this.categories.forEach(element => {
            if (this.currentWine.categories.includes(element.id) ) {
                document.getElementById(element.id).classList.add("active-category")
            }
        }); 
    },
    computed: {
        ...mapState(['categories', 'countries', 'wines'])
    }
}
</script>

<style>
.new-wine-wrap {
    width: 90%;
    margin:auto;
    margin-top: 20px;
    margin-bottom: 20px;
    background-color: white;
    text-align: left;
}
.new-wine-pad {
    padding: 5px;
    width: 100%;
}
.new-wine-col-25 {
    width: 25%;
    float:left;
}
.new-wine-col-45 {
    width: 45%;
    float:left;
}
.new-wine-col-30 {
    width: 30%;
    display:inline-block;
}
.new-wine-input {
    margin: 0 auto;
    margin-bottom: 20px;
    text-align: center;
}
.new-wine-input-text {
    padding: 10px;
}
.new-wine-input input {
    font-family: 'oswald';
    border: none;
    padding:10px;
    font-size: 16px;
    border: 3px solid rgb(245, 240, 240);
    resize: none;
    text-align: center;
}
.new-wine-input textarea {
    font-family: 'oswald';
    border: none;
    padding:10px;
    font-size: 16px;
    border: 3px solid rgb(245, 240, 240);
    resize: none;
    text-align: center;
}
.wine-input-long input {
    width:400px;
}
.wine-input-long textarea {
    width:400px;
}
.wine-input-short input {
    width:200px;
}
#new-wine-image-preview {
    position: relative;
    height:500px;
    overflow: hidden;
    background-color: #f0f0f0;
}
#new-wine-image-preview img {
    position: absolute;
    height:100%;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
}
.new-wine-categories-title {
    text-align: center;
    font-size: 26px;
}
.new-wine-agerating-title {
    text-align: center;
    font-size: 26px;
    margin-bottom: 10px;
}
.new-wine-agerating {
    padding-bottom: 10px;
}
.new-wine-agerating-col {
    display:inline-block;
    width: 32%;
    text-align: center;
}
.new-wine-agerating-col input {
    width:70%;
    padding: 10px;
    font-size: 16px;
    border: 3px solid rgb(245, 240, 240);
    resize: none;
    text-align: center;
}
.new-wine-agerating-add {
    margin: 0 auto;
    height: 40px;
    width: 100px;
    background-color: rgb(69, 144, 194);
    line-height: 40px;
    color: white;
    border-radius: 5px;
    cursor: pointer;
    text-align: center;
    margin-top: 10px;
}
.new-wine-agerating-delete {
    color: #b33b3b;
    font-weight: bold;
    border-radius: 5px;
    cursor: pointer;
    text-align: center;
}
.new-wine-sliders-wrap {
    width:100%;
}
.new-wine-slider p {
    width:15%;
    display:inline-block;
    text-align: center;
}
.new-wine-slider input {
    display:inline-block;
    width:69%;
}
.new-wine-categories-wrap {
    display:flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    width:50%;
    margin: auto;
    margin-top: 20px;
}
.new-wine-category{
    text-align: center;
    line-height: 40px;
    width:100px;
    height:40px;
    padding:10px;
    margin:5px;
    background-color: #F0F0F0;
    cursor: pointer;
}

.active-category {
    background-color: rgb(69, 144, 194);
    color: white;
}
.new-wine-buttons {
    position: relative;
    margin:0;
    margin-right: 40px;
    margin-top: 50px;
    height:100px;
    text-align: right;
}
.new-wine-buttons * {
    float:right;
    margin-left: 15px;
}
.new-wine-published {
    padding-top: 20px;
    margin-right: 50px;
    font-size: 23px;
}
.new-wine-published input {
    -webkit-appearance: checkbox;
    -moz-appearance: checkbox;
    appearance: checkbox;
    height: 30px;
    width: 30px;
}
.new-wine-select {
    width: 230px;
    padding: 10px;
    font-size: 16px;
    border: 3px solid rgb(245, 240, 240);
}

/* RANGE SLIDER */
.new-wine-sliders-title {
    text-align: center;
    font-size: 20px;
    padding-top: 20px;
    margin-bottom: 10px;
}
.rangeslider {
    height:20px;
    background: #d3d3d3;
}
.rangeslider::-webkit-slider-thumb {
  -webkit-appearance: none;
  appearance: none;
  width: 25px;
  height: 25px;
  border-radius: 5px;
  background: #bb3b3b;
  cursor: pointer;
}

.rangeslider::-moz-range-thumb {
  width: 25px;
  height: 25px;
  background: #4CAF50;
  cursor: pointer;
}
</style>